<template>
  <layout name="Notification">
    <VSystemMessage :primaryText="primaryText" :socialNetworks="socialNetworks">
      <!--Waiting for Vue 3 for multiply slots refactoring-->
      <div class="resend-password__wrapper">
        <div class="resend-password__content">
          <p class="description">
            You will receive an email with instructions about how to reset your
            password in a few minutes.
          </p>
          <div class="btn">
            Check Your Inbox
          </div>
        </div>

        <p class="footer">
          If you don't receive a link
          <v-link
            type="gray-underline"
            href="mailto:support@inkit.io"
            label="let us know"
            inverted
          />.
        </p>
      </div>
    </VSystemMessage>
  </layout>
</template>

<script>
import Vue from "vue";
import VLink from "@/components/VLink";
import Layout from "@/layouts/Layout";
import VSystemMessage from "@/components/VSystemMessage";

export default Vue.component("ResetPasswordInitSuccess", {
  components: {
    Layout,
    VSystemMessage,
    VLink
  },

  data() {
    return {
      primaryText: "Link has been sent!",
      socialNetworks: ["facebook", "twitter", "instagram"]
    };
  }
});
</script>

<style lang="scss" scoped>
$ns: "resend-password";

.#{$ns}__wrapper {
  .#{$ns}__content {
    .description {
      text-align: center;
      line-height: 1.62;
      color: $secondary-text-color;
    }
  }


  .footer {
    font-family: "Lato-Light", Arial, "Helvetica Neue", Helvetica, sans-serif;
    color: $secondary-text-color;
    text-align: center;
  }
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 58px;
  margin-bottom: 94px;

  height: 60px;
  width: 436px;
  color: $primary-color;
  font-size: 32px;
  line-height: 1.2;
}

/*Media*/
@media only screen and (max-width: 600px) {

}
</style>
